// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
let __webpack_exports__ = __webpack_require__("./src/index.js");
